import React, {useState} from 'react';
import {PartnerFavoriteFeature} from '../../../../PulsoidClient';
import {PartnerPreviewFavorite} from './PartnerPreviewFavorite';
import css from './PartnerPreviewFavorite.module.css';
import {FeatureDescriptionModal} from '../../../../system/FeatureDescriptionModal';

type PartnerPreviewFavoriteFeatureProps = {
  feature: PartnerFavoriteFeature;
};

export const PartnerPreviewFavoriteFeature = ({
  feature,
}: PartnerPreviewFavoriteFeatureProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <PartnerPreviewFavorite
        onClick={() => setShowModal(true)}
        actionLabel="read"
      >
        <div className={css.feature}>
          <img
            className={css.featureIcon}
            src={feature?.imageUrl}
            alt={feature?.title}
          />
        </div>
      </PartnerPreviewFavorite>

      <FeatureDescriptionModal
        controlled
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        id={feature.descriptionId}
      />
    </>
  );
};
